import { useQuery } from "@tanstack/react-query";
import { fetchModelOptions } from "../Api/llm";

export const useLLMModels = () => {
  return useQuery({
    queryKey: ["llmModels"],
    queryFn: () => fetchModelOptions(),
    staleTime: Infinity,
  });
};
